export default __webpack_public_path__ + "static/media/gdrive1.4e9776bd.gif";